(function () {
    'use strict';
    angular
        .module('payroll')
        .controller('PayrollListController', PayrollListController);
    PayrollListController.$inject = ['$uibModal', '$state', '$stateParams', 'PayrollService', 'AdmService'];
    function PayrollListController($uibModal, $state, $stateParams, PayrollService, AdmService) {
        var vm = this;
        vm.tag = '';
        vm.sellerSelected = '';
        vm.sellersList = '';
        vm.payrollList = [];
        vm.status = {id : -1, name : '--- All ---'};
        vm.statusList = [{id : -1, name : '--- All ---'}, {id : 'paid', name : 'Paid'}, {id : 'waiting', name : 'Waiting'}];
        vm.date = {startDate: null, endDate: null};
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };
        vm.getPayrolls             = getPayrolls;
        vm.loadSellers             = loadSellers;
        vm.clear                   = clear;
        vm.paymentModal            = paymentModal;
        vm.remove                  = remove;
        vm.edit                    = edit;
        vm.sendEmail               = sendEmail;
        vm.sendEmailTo             = sendEmailTo;
        vm.setPayrollTag           = setPayrollTag;

        vm.selectOptionAll = [{
            name: '--- All ---',
            id: -1
        }];
        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems;
        vm.currentPage;
        vm.itemsPerPage;
        vm.page = 1;

        activate();

        function activate() {
            vm.loadSellers();
             vm.getPayrolls();
        }

        function loadSellers() {
            AdmService.getAll({'not_deleted':'1'}).then(function(response) {
                vm.sellersList = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function getPayrolls() {
            let query = [];

            query['paginate'] = 20;    

            if (vm.tag !== '') {
                query['tag'] = vm.tag;
            }

            if (vm.sellerSelected.id > -1) {
                query['seller_id'] = vm.sellerSelected.id;
            }

            if (vm.status.id !== -1 ) {
                query['status'] = vm.status.id;
            }

            if ((vm.date.startDate !== null ) && (vm.date.endDate !== null)) {
                query['start'] = vm.date.startDate.format('Y-MM-DD');
                query['end'] = vm.date.endDate.format('Y-MM-DD');
            }

            if (vm.page > 1) {
                query['page'] = vm.page;
            }
            
            PayrollService.getPayroll(query).then(function(response) {
                vm.payrollList = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function clear() {
            vm.sellerSelected = '';
            vm.tag = '';
            vm.date = {startDate: null, endDate: null};
            vm.status = {id : -1, name : '--- All ---'};
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getPayrolls();
        }

        function remove(payroll) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this payroll?')
                .set('onok', function (){
                    let query = [];
                    query['id'] = payroll.id;
                    PayrollService.deletePayroll(query).then(function (response) {
                        vm.payrollList.splice(vm.payrollList.indexOf(payroll), 1);
                        alertify.notify('Commissions removed', 'success', 3);
                    });  
                }).show();
        }

        function paymentModal() {
            $uibModal.open({
                templateUrl: 'templates/payroll/paymentModal/paymentModal.html',
                controller: 'paymentModalController',
                controllerAs:'paymentModal',
                windowClass: 'app-modal-window2',
                resolve: {
                    payrollId : function () {
                         return null
                    },
                    getPayrolls : function() {
                        return vm.getPayrolls;get
                    },
                    setPayrollTag: function() {
                        return vm.setPayrollTag;
                    }
                 }
            });

        }

        function edit(payroll) {
            let id = payroll.id;
            $uibModal.open({
                templateUrl: 'templates/payroll/paymentModal/paymentModal.html',
                controller: 'paymentModalController',
                controllerAs:'paymentModal',
                windowClass: 'app-modal-window2',
                backdrop  : 'static',
                keyboard: false,
                resolve: {
                    payrollId : function () {
                        return id
                    },
                    getPayrolls : function() {
                        return vm.getPayrolls;
                    },
                    setPayrollTag : function() {
                        return vm.setPayrollTag;
                    }
                }
            });
        }

        function sendEmail(payroll) {
            let query = {};           

            query['payroll_id'] = payroll.id;            

            PayrollService.sendEmailPayrrolReport(query).then(function (response) {
                alertify.success('Report sent!');
            });
        }

        function sendEmailTo(payroll) {            
            alertify
            .prompt("Send this payroll to:", "c.seixas@fpp.world")
            .set('labels', {
                ok: 'Ok',
                cancel: 'Cancelar'
            })
            .set('title', 'Alert!')
            .set('onok', function(evt, value) {
                let query = {};           
                query['payroll_id'] = payroll.id;
                query['send_to'] = value;
                PayrollService.sendEmailPayrrolReport(query).then(function (response) {
                    alertify.success('Report sent!');
                });
            })
            .show();            
        }

        function setPayrollTag(tag) {
            vm.tag = tag;
        }

    }
})();